"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var s = require("./TextField.scss");
var Translate_1 = require("./../../Translate");
var TextField = (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            var node = e.target;
            _this.props.onChange({
                value: node.value,
                name: _this.props.name,
                isValid: _this.props.validate(node.value),
            });
        };
        _this.handleBlur = function () {
            // field become touched, for validation
            _this.props.onChange({
                value: _this.props.value,
                name: _this.props.name,
                isValid: _this.props.isValid,
            });
        };
        _this.isError = function () { return !_this.props.isValid && _this.props.touched; };
        return _this;
    }
    TextField.prototype.renderErrorMessage = function () {
        if (!this.isError() || !this.props.errorMessage) {
            return null;
        }
        return (React.createElement("label", { className: s.errorLabel, htmlFor: name }, Translate_1.translate({ forKey: this.props.errorMessage })));
    };
    TextField.prototype.render = function () {
        var _a = this.props, required = _a.required, value = _a.value, name = _a.name, label = _a.label;
        return (React.createElement("div", { className: s.root, "data-hook": "cashier-payments-method-field-textField" },
            React.createElement("label", { className: s.label, htmlFor: name },
                required ? '* ' : '',
                Translate_1.translate({ forKey: label })),
            React.createElement("input", { className: s.input + " " + (this.isError() ? s.errorInput : ''), id: name, name: name, required: required, "data-hook": "cashier-payments-method-field-textField-" + name, value: value, onChange: this.handleChange, onBlur: this.handleBlur }),
            this.renderErrorMessage()));
    };
    return TextField;
}(React.Component));
exports.default = TextField;
//# sourceMappingURL=TextField.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/TextField/TextField.js
// module id = 207
// module chunks = 0 1